import React from 'react';
import './PropertyDescription.css';

const PropertyDescription = () => {
  return (
    <div className="desc-container">
      <h2>Property Description:</h2>
      <p>
        This exceptional villa offers a perfect blend of modern design, spacious 
        interiors, and premium finishes. Thoughtfully planned to maximize 
        comfort and natural light, the home features elegant living areas, 
        private outdoor spaces, and high-quality craftsmanship throughout.
      </p>
    </div>
  );
};

export default PropertyDescription;